import { useQueryStates } from "nuqs";

import type { ParserMap } from "nuqs";

/**
 * useQueryStates wrapper. Session storage persist/restore is handled centrally
 * in DataTableSearchProvider (all-or-nothing per path).
 */
export function usePersistedQueryStates<Parsers extends ParserMap>(
  parsers: Parsers,
  options?: Parameters<typeof useQueryStates<Parsers>>[1]
) {
  return useQueryStates(parsers, options);
}
